import { render, staticRenderFns } from "./SessionItem.vue?vue&type=template&id=6cbf8028&scoped=true"
import script from "./SessionItem.vue?vue&type=script&lang=js"
export * from "./SessionItem.vue?vue&type=script&lang=js"
import style0 from "./SessionItem.vue?vue&type=style&index=0&id=6cbf8028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf8028",
  null
  
)

export default component.exports